export const GetAccessToken = () => localStorage.getItem('am.carfax.auth.access_token');

const SetAccessToken = (token: string) =>
  localStorage.setItem('am.carfax.auth.access_token', token);

export const GetRefreshToken = () => localStorage.getItem('am.carfax.auth.refresh_token');

const SetRefreshToken = (refreshToken: string) =>
  localStorage.setItem('am.carfax.auth.refresh_token', refreshToken);

export const GetQueryParameterCode = () => localStorage.getItem('am.carfax.queryparameter');

const GetExpiresAt = () => {
  const expiresAt = localStorage.getItem('am.carfax.auth.expires_at');
  return expiresAt !== null ? parseInt(expiresAt, 10) : 0;
};

const SetExpiresAt = (expiresInSeconds: number) =>
  localStorage.setItem(
    'am.carfax.auth.expires_at',
    (Date.now() + expiresInSeconds * 1000).toString(),
  );

const ResetRefreshExpiresAt = () => {
  const refreshTokenExpirationDate = new Date();
  refreshTokenExpirationDate.setDate(refreshTokenExpirationDate.getDate() + 29);

  localStorage.setItem(
    'am.carfax.auth.refresh_expires_at',
    refreshTokenExpirationDate.getTime().toString(),
  );
};

export const RenewToken = (tokenResponse: any) => {
  SetAccessToken(tokenResponse.access_token);
  SetRefreshToken(tokenResponse.refresh_token);
  SetExpiresAt(tokenResponse.expires_in);
  ResetRefreshExpiresAt();
};

export const IsAccessTokenValid = () => GetExpiresAt() > Date.now();

export const RemoveAll = () => {
  localStorage.removeItem('am.carfax.auth.statenonce');
  localStorage.removeItem('am.carfax.auth.originalnonce');
  localStorage.removeItem('am.carfax.auth.access_token');
  localStorage.removeItem('am.carfax.auth.refresh_token');
  localStorage.removeItem('am.carfax.auth.expires_at');
  localStorage.removeItem('am.carfax.auth.refresh_expires_at');
};

export const GetUserName = () => localStorage.getItem('am.carfax.auth.userName');

export const ValidateUser = (userName: string) => userName === GetUserName();

const GetRefreshExpiresAt = () =>
  localStorage.getItem('am.carfax.auth.refresh_expires_at') !== null
    ? localStorage.getItem('am.carfax.auth.refresh_expires_at')
    : 0;

export const IsRefreshTokenValid = () => GetRefreshExpiresAt() > Date.now();

export const IsSignIntoCarFax = IsRefreshTokenValid();

export const SetNonce = (nonce: string) => localStorage.setItem('am.carfax.auth.statenonce', nonce);

export const getRandomString = (length) => {
  const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
  }
  return result;
};

export const clientId = () => {
  const config = localStorage.getItem('Config');

  return config ? JSON.parse(config).carFaxClientId : null;
};
export const callBackUrl = () => {
  const config = localStorage.getItem('Config');

  return config ? JSON.parse(config).carFaxCallBackUrl : null;
};

export const IsLoggedIntoCarFax = () => IsRefreshTokenValid();

export const HasAccessToken = () => GetAccessToken() !== null;
